import { Box, Grid } from "@mui/material/index";
import CBTaxCodeSearchFilter from "../filters/CBTaxCodeSearchFilter";
import CBVatNumberSearchFilter from "../filters/CBVatNumberSearchFilter";
import CBDrvLicenceNumberSearchFilter from "../filters/CBDrvLicenceNumberSearchFilter";
import CBResetFiltersButton from "../buttons/CBResetFiltersButton";
import CBAdvancedFiltersButton from "../buttons/CBAdvancedFiltersButton";
import CBSearchButton from "../buttons/CBSearchButton";
import CBEmailSearchFilter from "../filters/CBEmailSearchFilter";
import CBFirstNameSearchFilter from "../filters/CBFirstNameSearchFilter";
import CBLastNameSearchFilter from "../filters/CBLastNameSearchFilter";
import CBBusinessNameSearchFilter from "../filters/CBBusinessNameSearchFilter";
import CBCustomerIdentifierSearchFilter from "../filters/CBCustomerIdentifierSearchFilter";
import { useTranslation } from "react-i18next";
import CBPartnerTypeSearchFilter from "../filters/CBPartnerTypeSearchFilter";
import CBDossierStatusSearchFilter from "../filters/CBDossierStatusSearchFilter";
import CBDigitalIdentityStatusSearchFilter from "../filters/CBDigitalIdentityStatusSearchFilter";
import CBDigitalIdentitySearchFilter from "../filters/CBDigitalIdentitySearchFilter";
import CBDossierOriginSearchFilter from "../filters/CBDossierOriginSearchFilter";

interface CBSearchProps {
    showPartnerTypeFilter: boolean,
    showExtraFilters: boolean,
    onAdvancedFiltersClick: () => void,
    onReset: () => void
}

const CBSearch = ({
    showPartnerTypeFilter,
    showExtraFilters,
    onAdvancedFiltersClick,
    onReset
}: CBSearchProps) => {

    const { t } = useTranslation('customerbase');

    return (
        <>
            <Box>
                <Grid container spacing={2} alignItems="center">
                    <Grid item lg={3} md={6} xs={12}>
                        <CBTaxCodeSearchFilter />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <CBVatNumberSearchFilter />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <CBDrvLicenceNumberSearchFilter />
                    </Grid>
                    <Grid item container lg={3} md={6} xs={12} display="flex-end" alignItems="center">
                        <Grid item xs={1} />
                        <Grid item xs={4}>
                            <CBResetFiltersButton onClick={onReset} />
                        </Grid>
                        <Grid item xs={5}>
                            <CBAdvancedFiltersButton
                                description={showExtraFilters ? t("searchTooltip.closeFilters") : t("searchTooltip.advancedFilters")}
                                onClick={onAdvancedFiltersClick}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <CBSearchButton />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container spacing={2} alignItems="center">
                    <Grid item lg={3} md={6} xs={12}>
                        <CBEmailSearchFilter />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <CBFirstNameSearchFilter />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <CBLastNameSearchFilter />
                    </Grid>
                    <Grid item lg={3} md={6} xs={12}>
                        <CBBusinessNameSearchFilter />
                    </Grid>
                </Grid>
            </Box>
            
            {showExtraFilters &&
                <Box>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item lg={3} md={6} xs={12}>
                            <CBCustomerIdentifierSearchFilter />
                        </Grid>
                        {showPartnerTypeFilter &&
                            <Grid item lg={3} md={6} xs={12}>
                                <CBPartnerTypeSearchFilter />
                            </Grid>
                        }
                        <Grid item lg={3} md={6} xs={12}>
                            <CBDossierStatusSearchFilter />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                            <CBDossierOriginSearchFilter />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                            <CBDigitalIdentitySearchFilter />
                        </Grid>
                        <Grid item lg={3} md={6} xs={12}>
                            <CBDigitalIdentityStatusSearchFilter />
                        </Grid>
                    </Grid>
                </Box>
            }
        </> 
    )

}

export default CBSearch;

/*<Grid item lg={3} md={6} xs={12}>
    <Controller
        control={form.control}
        name={"customerType"}
        render={({field}) => (
            <Autocomplete
                fullWidth
                id="customerType"
                options={sapEnum.customerTypes}
                renderInput={(params:any) => 
                    <TextField 
                        fullWidth
                        {...params}
                        label={t("customerType")}
                    />
                }
                value={field.value ? sapEnum.customerTypes.find((c) => c.key === field.value) : null}
                getOptionLabel={(option:any) => option?.key}
                onChange={(_event, value) => {
                    field.onChange(value);
                    form.setValue("customerType", value? value.key : "")
                }}
            />
        )}  
    /> 
</Grid>*/
/* 29/03/23 - PER ORA SI NASCONDE*/
/*<Grid item lg={3} md={6} xs={12}>
<Controller
control={form.control}
name={"role"}
render={({field}) => (
    <Autocomplete
        fullWidth
        multiple
        id="role"
        options={sapEnum.roles}
        renderInput={(params:any) => 
            <TextField 
                fullWidth
                {...params}
                label={t("role")}
            />
        }
        value={field.value ? sapEnum.roles.filter((c) => field.value?.includes(c.key)) : []}
        getOptionLabel={(option:any) => option?.key}
        onChange={(_event, value) => {
            field.onChange(value);
            let v = value?.map((val) => val?.key).filter(Boolean) || [];
            
            form.setValue("role", v);  
        }}
    />
)}
/>
</Grid>*/
/*<Grid item lg={3} md={6} xs={12}>
<Controller
control={form.control}
name={"vip"}
render={({field}) => (
    <Autocomplete
        fullWidth
        id="vip"
        options={sapEnum.vips}
        renderInput={(params:any) => 
            <TextField 
                fullWidth
                {...params}
                label={t("vip")}
            />
        }
        value={field.value ? sapEnum.vips.find((c) => c.key === field.value) : null}
        getOptionLabel={(option:any) => t(`sapEnum.vips.${option?.key}`)}
        onChange={(_event, value) => {
            field.onChange(value);
            form.setValue("vip", value? value.key : "")
        }}
    />
)} 
/>
    </Grid>*/